import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import React from 'react';
import { RouteProps, Route, useHistory } from 'react-router-dom';
import { datadogRum } from '@datadog/browser-rum';
import { ErrorPage, Loading } from '@guildeducationinc/recess';
import { logDataDogError } from '@src/utilities/datadog';

export const ProtectedRoute: React.FC<RouteProps> = props => {
	const { userHasRolesAny, userFromIdToken: user } = useMemberExperienceAuth();
	const history = useHistory();

	const accessAllowed = userHasRolesAny(['admin', 'coach', 'superadmin']);

	const userFieldsForDataDog = {
		email: user.email,
		roles: user.roles,
	};

	if (accessAllowed) {
		datadogRum.addAction('ProtectedRouteAccessed', userFieldsForDataDog);
	} else {
		logDataDogError(
			new Error('Insufficient permission to access member services route'),
			'MemberServiceRouteError',
			userFieldsForDataDog
		);
	}

	if (!user) {
		return <Loading label='protected route' />;
	}

	return accessAllowed ? (
		<Route {...props} />
	) : (
		<ErrorPage goBack={history.goBack} message={null} />
	);
};
